import { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";

import DataTable from "react-data-table-component";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import HeaderDashboard from "../../Components/HeaderDashboard";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import "jquery-ui-dist/jquery-ui.css";
import { AuthContext } from "../../Routes/AuthProvider";
import { InsuranceTransactionReport } from "../../Services/ReportsApi";

const AllTransactions = () => {
    const { name, userName, roles } = useContext(AuthContext);

    const userRole = roles?.[0];

    const isTmcAdmin = roles?.includes("TMC Operations");
    const isCorpTravel = roles?.includes("Corporate Traveller");
    const isCorpAdmin = roles?.includes("CORP ADMINISTRATOR");
    const navigate = useNavigate();
    const [filters, setFilters] = useState({
        fromDate: "",
        toDate: "",
        bookingRefNo: "",
        bookingStatus: "",
    });

    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [summary, setSummary] = useState({});

    const tableWrapperRef = useRef(null);
    const [visibleColumns, setVisibleColumns] = useState([]);
    const [hiddenColumns, setHiddenColumns] = useState([]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    const convertToDate = (str) => {
        if (!str) return null;
        const [day, month, year] = str.split("/");
        return new Date(`${year}-${month}-${day}`);
    };

    useEffect(() => {
        $("#fromDate").datepicker({
            dateFormat: "dd/mm/yy",
            maxDate: 0,
            onSelect: function (dateText) {
                setFilters((prev) => ({
                    ...prev,
                    fromDate: dateText,
                }));
            },
        });
    }, []);

    useEffect(() => {
        $("#toDate").datepicker({
            dateFormat: "dd/mm/yy",
            maxDate: 0,
            onSelect: function (dateText) {
                setFilters((prev) => ({
                    ...prev,
                    toDate: dateText,
                }));
            },
        });
    }, []);

    // UPDATE minDate of ToDate WHEN fromDate changes
    useEffect(() => {
        if (filters.fromDate) {
            const minD = convertToDate(filters.fromDate);
            $("#toDate").datepicker("option", "minDate", minD);
        }
        // Auto search when fromDate changes (like in second code)
        handleSearch();
    }, [filters.fromDate]);

    const handleSearch = async () => {
        setLoading(true);
        try {
            const requestBody = {
                FromDate: filters.fromDate,
                ToDate: filters.toDate,
                ReferenceNo: filters.bookingRefNo,
                BookingStatus: filters.bookingStatus,
                UserName: userName,
            };
            console.log("requestBody:", requestBody);
            const data = await InsuranceTransactionReport(requestBody);

            const all = data?.allTransactions;
            //const list = data?.allTransactions || [];
             const list = data?.allTransactions?.transactions || [];
            setTransactions(list);
            console.log("setTransactions", list);
        } catch (error) {
            console.error("Error fetching data:", error);
            alert(error.message);
        } finally {
            setLoading(false);
        }
    };

    const [filterText, setFilterText] = useState("");

    const insuranceTransactions = transactions || [];

    const filteredItems = insuranceTransactions.filter(
        (item) =>
            item.referenceNo?.toLowerCase().includes(filterText.toLowerCase()) ||
            item.organizationName?.toLowerCase().includes(filterText.toLowerCase()) ||
            item.policyNo?.toLowerCase().includes(filterText.toLowerCase()) ||
            item.destination?.toLowerCase().includes(filterText.toLowerCase())
    );

    const StatusBadge = ({ status }) => {
        const isConfirmed = status?.toLowerCase() === "confirmed" || status?.toLowerCase() === "active";
        const isPending = status?.toLowerCase() === "pending";

        return (
            <span
                style={{
                    background: isConfirmed
                        ? "#e7f8ec"
                        : isPending
                        ? "#fff3d6"
                        : "#f8f9fa",
                    color: isConfirmed
                        ? "#00a63e"
                        : isPending
                        ? "#ff9800"
                        : "#6c757d",
                    padding: "6px 12px",
                    borderRadius: "30px",
                    fontSize: "12px",
                    fontWeight: "600",
                }}
            >
                {status || "N/A"}
            </span>
        );
    };

    const allColumns = [
        {
            id: "referenceNo",
            name: "Ref No.",
            selector: row => row.referenceNo,
            sortable: true,
            cell: row => (
                <span
                    title="Details"
                    style={{
                        color: "#0d47a1",
                        fontWeight: "600",
                        cursor: "pointer"
                    }}
                >
                    {row.referenceNo}
                </span>
            )
        },

        ...(!isCorpTravel ? [
            {
                id: "organization",
                name: "Entity Name",
                selector: row => row.organizationName,
                sortable: true,
                grow: 2,
                cell: row => (
                    <>
                        {row.organizationName} ({row.corporateCode})
                    </>
                ),
                priority: 2,
            },
            {
                id: "paxName",
                name: "Pax Name",
                selector: row => row.passengerNames,
                sortable: true,
                grow: 2,
                cell: row => (
                    <>
                        {row.passengerNames}
                    </>
                ),
                priority: 3,
            }
        ] : []),

        {
            id: "bookingDate",
            name: "Booking Date",
            selector: row => row.createdOn,
            sortable: true,
            priority: 4,
            grow: 2,
            cell: row => (
                <>
                    {row.createdOn}
                </>
            )
        },

        {
            id: "destination",
            name: "Destination",
            selector: row => row.destination,
            sortable: true,
            grow: 2,
            cell: row => (
                <>
                    {row.destination}
                </>
            )
        },

        {
            id: "policyNo",
            name: "Policy No.",
            selector: row => row.policyNo,
            sortable: true,
            grow: 2,
            cell: row => (
                <>
                    {row.policyNo || "-"}
                </>
            )
        },

        {
            id: "startDate",
            name: "Start Date",
            selector: row => row.startDate,
            sortable: true,
            cell: row => {
                if (!row.startDate) return "-";
                return row.startDate;
            }
        },

        {
            id: "endDate",
            name: "End Date",
            selector: row => row.endDate,
            sortable: true,
            cell: row => {
                if (!row.endDate) return "-";
                return row.endDate;
            }
        },

        {
            id: "paymentStatus",
            name: "Payment",
            selector: row => row.paymentStatus,
            sortable: true,
            cell: row => (
                <StatusBadge status={row.paymentStatus} />
            ),
            priority: 9,
        },

        {
            id: "bookingStatus",
            name: "Policy",
            selector: row => row.bookingStatus,
            sortable: true,
            cell: row => (
                <StatusBadge status={row.bookingStatus} />
            ),
            priority: 10,
        },

        {
            id: "amount",
            name: "Amount",
            selector: row => row.totalFare || row.amount,
            sortable: true,
            grow: 2,
            cell: row => (
                <>
                    {row.totalFare || row.amount || "-"}
                </>
            )
        },

        // {
        //     id: "action",
        //     name: "Action",
        //     selector: row => row.action,
        //     sortable: false,
        //     cell: row => (
        //         <button
        //             className="btn btn-sm btn-primary"
        //             onClick={() => navigate(`/reservations/insurance/Details?ref=${row.referenceNo}`)}
        //         >
        //             View
        //         </button>
        //     )
        // }
    ];

    const calculateResponsiveColumns = () => {
        if (!tableWrapperRef.current) return;

        const containerWidth = tableWrapperRef.current.clientWidth;
        const expanderWidth = 45;

        const columnWidths = {
            referenceNo: 130,
            organization: 180,
            bookingDate: 130,
            destination: 150,
            policyNo: 120,
            startDate: 120,
            endDate: 120,
            paymentStatus: 140,
            bookingStatus: 140,
            amount: 110,
            action: 90,
        };

        let availableWidth = containerWidth - expanderWidth;

        const visible = [];
        const hidden = [];

        // First column ALWAYS visible
        visible.push(allColumns[0]);
        availableWidth -= columnWidths.referenceNo;

        // Check remaining columns based on actual available width
        allColumns.slice(1).forEach(column => {
            const width = columnWidths[column.id] || 120;
            if (availableWidth >= width) {
                visible.push(column);
                availableWidth -= width;
            } else {
                hidden.push(column);
            }
        });

        setVisibleColumns(visible);
        setHiddenColumns(hidden);
    };

    useEffect(() => {
        calculateResponsiveColumns();

        const resizeObserver = new ResizeObserver(() => {
            calculateResponsiveColumns();
        });

        if (tableWrapperRef.current) {
            resizeObserver.observe(tableWrapperRef.current);
        }

        window.addEventListener("resize", calculateResponsiveColumns);

        return () => {
            resizeObserver.disconnect();
            window.removeEventListener("resize", calculateResponsiveColumns);
        };
    }, []);

    const ExpandedComponent = ({ data }) => {
        return (
            <div className="expanded-data">
                {hiddenColumns.map(column => (
                    <div key={column.id} className="expanded-item">
                        <strong>{column.name}:</strong>
                        <span>
                            {column.cell
                                ? column.cell(data)
                                : column.selector
                                ? column.selector(data)
                                : "-"}
                        </span>
                    </div>
                ))}
            </div>
        );
    };

    const customStyles = {
        headRow: {
            style: {
                background: "#110942",
                minHeight: "55px"
            }
        },
        headCells: {
            style: {
                color: "#fff",
                fontWeight: 600,
                fontSize: "13px"
            }
        },
        rows: {
            style: {
                minHeight: "55px",
                '&:hover': {
                    backgroundColor: "#f8f9ff"
                }
            }
        }
    };

    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const month = now.toLocaleString("en-US", { month: "short" });
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const excelName = `InsuranceTransaction_Report_${day}${month}_${hours}_${minutes}`;

    const exportToExcel = (data, fileName = "Transactions") => {
        const worksheet = XLSX.utils.json_to_sheet(data);
        worksheet["!cols"] = [
            { wch: 15 }, // ReferenceNo
            { wch: 50 }, // Organization
            { wch: 20 }, // BookingDate
            { wch: 25 }, // Destination
            { wch: 20 }, // PolicyNo
            { wch: 20 }, // StartDate
            { wch: 20 }, // EndDate
            { wch: 20 }, // PaymentStatus
            { wch: 20 }, // BookingStatus
            { wch: 15 }, // Amount
        ];

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Transactions");

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const fileData = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(fileData, `${fileName}.xlsx`);
    };

    const exportInsuranceExcel = () => {
        const exportData = filteredItems.map((item) => ({
            ReferenceNo: item.referenceNo,
            EntityName: item.organizationName,
            PaxName: item.passengerNames,
            BookingDate: item.createdOn,
            Destination: item.destination,
            PolicyNo: item.policyNo || "-",
            StartDate: item.startDate || "-",
            EndDate: item.endDate || "-",
            PaymentStatus: item.paymentStatus || "-",
            PolicyStatus: item.bookingStatus || "-",
            Amount: item.totalFare || item.amount || "-",
        }));

        exportToExcel(exportData, excelName);
    };

    const exportInsurancePDF = () => {
        const doc = new jsPDF();

        autoTable(doc, {
            head: [[
                "Ref No",
                "Organization",
                "PaxName",
                "Booking Date",
                "Destination",
                "Policy No",
                "Start Date",
                "End Date",
                "Payment",
                "Policy",
                "Amount"
            ]],
            body: filteredItems.map((item) => [
                item.referenceNo,
                item.organizationName,
                item.passengerNames,
                item.createdOn,
                item.destination,
                item.policyNo || "-",
                item.startDate || "-",
                item.endDate || "-",
                item.paymentStatus || "-",
                item.bookingStatus || "-",
                item.totalFare || item.amount || "-"
            ]),
        });

        doc.save(excelName + ".pdf");
    };

    return (
        <>
            <HeaderDashboard />

            <div className="toolbar py-2" id="kt_toolbar">
                <div className="container-fluid d-flex align-items-center">
                    <div className="flex-grow-1">
                        <div className="page-title d-flex align-items-center flex-wrap">
                            <h1 className="text-gray-900 fw-bold fs-3">Reservations</h1>
                            <span className="h-20px border-gray-200 border-start mx-3"></span>
                            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                                <li class="breadcrumb-item text-muted">Insurance</li>
                                <li class="breadcrumb-item">
                                    <span class="bullet bg-gray-200 w-5px h-2px"></span>
                                </li>

                                <li class="breadcrumb-item text-gray-900">All Transactions</li>
                            </ul>
                        </div>
                    </div>
                    <div class="d-flex align-items-center flex-wrap">
                        <div class="flex-shrink-0 me-2 d-none-mob">
                            <ul class="nav" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <a href='/Dashboard'>
                                        <img src='/assets/images/back.png' width={30} /> </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {/* Filters */}
            <section className="wraper">
                <div className="box_shadow mt-14">
                    {["TMC Operations", "TMC Manager"].some(role => roles?.includes(role)) && (
                        <div className="row">
                            <div className="col-md-3 mb-1">
                                <label>Organization </label>
                                <select
                                    className="form-select form-select-solid"
                                    name="organization"
                                    onChange={handleChange}
                                >
                                    <option value="">- All -</option>
                                </select>
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>Company </label>
                                <select
                                    className="form-select form-select-solid"
                                    name="company"
                                    onChange={handleChange}
                                >
                                    <option value="">- All -</option>
                                </select>
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>Legal Entity </label>
                                <select
                                    className="form-select form-select-solid"
                                    name="legalEntity"
                                    onChange={handleChange}
                                >
                                    <option value="">- All -</option>
                                </select>
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>Corporate Traveller </label>
                                <select
                                    className="form-select form-select-solid"
                                    name="corporateTraveller"
                                    onChange={handleChange}
                                >
                                    <option value="">- All -</option>
                                </select>
                            </div>

                            <div className="col-md-3 mb-1">
                                <label>From Date</label>
                                <input
                                    type="text"
                                    id="fromDate"
                                    className="form-control"
                                    placeholder="From Date"
                                    readOnly
                                />
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>To Date</label>
                                <input
                                    type="text"
                                    id="toDate"
                                    className="form-control"
                                    placeholder="To Date"
                                    readOnly
                                />
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>Reference No</label>
                                <input
                                    className="form-control form-control-solid"
                                    type="text"
                                    name="bookingRefNo"
                                    value={filters.bookingRefNo}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Search Button */}
                            <div className="col-md-3 mb-1">
                                <button
                                    type="button"
                                    className="btn btn-primary mt-7"
                                    onClick={handleSearch}
                                    disabled={loading}
                                >
                                    {loading ? "Loading..." : "Search"}
                                </button>
                            </div>
                        </div>
                    )}

                    {roles?.includes("Corp Travel Manager", "Corp Administrator") && (
                        <div className="row">
                            <div className="col-md-3 mb-1">
                                <label>From Date</label>
                                <input
                                    type="text"
                                    id="fromDate"
                                    className="form-control"
                                    placeholder="From Date"
                                    readOnly
                                />
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>To Date</label>
                                <input
                                    type="text"
                                    id="toDate"
                                    className="form-control"
                                    placeholder="To Date"
                                    readOnly
                                />
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>Reference No</label>
                                <input
                                    className="form-control form-control-solid"
                                    type="text"
                                    name="bookingRefNo"
                                    value={filters.bookingRefNo}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Search Button */}
                            <div className="col-md-3 mb-1">
                                <button
                                    type="button"
                                    className="btn btn-primary mt-7"
                                    onClick={handleSearch}
                                    disabled={loading}
                                >
                                    {loading ? "Loading..." : "Search"}
                                </button>
                            </div>
                        </div>
                    )}

                    {roles?.includes("Corporate Traveller") && (
                        <div className="row">
                            <div className="col-md-3 mb-1">
                                <label>From Date</label>
                                <input
                                    type="text"
                                    id="fromDate"
                                    className="form-control"
                                    placeholder="From Date"
                                    readOnly
                                />
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>To Date</label>
                                <input
                                    type="text"
                                    id="toDate"
                                    className="form-control"
                                    placeholder="To Date"
                                    readOnly
                                />
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>Reference No</label>
                                <input
                                    className="form-control form-control-solid"
                                    type="text"
                                    name="bookingRefNo"
                                    value={filters.bookingRefNo}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Search Button */}
                            <div className="col-md-3 mb-1">
                                <button
                                    type="button"
                                    className="btn btn-primary mt-7"
                                    onClick={handleSearch}
                                    disabled={loading}
                                >
                                    {loading ? "Loading..." : "Search"}
                                </button>
                            </div>
                        </div>
                    )}
                </div>

                <div className="box_shadow mt-3">
                    <div className="row mb-3">
                        <div className="col-md-8 col-lg-8">
                            <button
                                className="btn btn-success me-2"
                                onClick={exportInsuranceExcel}
                            >
                                <i className="fa fa-file-excel"></i>
                                Excel
                            </button>
                            <button
                                className="btn btn-danger"
                                onClick={exportInsurancePDF}
                            >
                                <i className="fa fa-file-pdf"></i>
                                PDF
                            </button>
                        </div>
                        <div className="col-md-4 ms-auto">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search Ref No, Organization, Policy..."
                                value={filterText}
                                onChange={(e) =>
                                    setFilterText(e.target.value)
                                }
                            />
                        </div>
                    </div>

                    <div ref={tableWrapperRef} className="transaction-table-wrapper">
                        <DataTable
                            columns={visibleColumns}
                            data={filteredItems}
                            progressPending={loading}
                            pagination
                            paginationPerPage={10}
                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                            customStyles={customStyles}
                            highlightOnHover
                            responsive
                            persistTableHead
                            noDataComponent="No Insurance Transactions Found"
                            expandableRows={hiddenColumns.length > 0}
                            expandableRowsComponent={ExpandedComponent}
                            expandOnRowClicked={false}
                            expandableRowsHideExpander={false}
                            expandableIcon={{
                                collapsed: <span className="table-plus-icon">+</span>,
                                expanded: <span className="table-plus-icon">−</span>,
                            }}
                        />
                    </div>
                </div>
            </section>
        </>
    );
};

export default AllTransactions;